import { render, staticRenderFns } from "./SequenceServer.vue?vue&type=template&id=4964806f&scoped=true&"
import script from "./SequenceServer.vue?vue&type=script&lang=js&"
export * from "./SequenceServer.vue?vue&type=script&lang=js&"
import style0 from "./SequenceServer.vue?vue&type=style&index=0&id=4964806f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4964806f",
  null
  
)

export default component.exports